export default __webpack_public_path__ + "static/media/alsoAvaOnGplyStore.d62eea28.png";